// EditContext.js
import { createContext, useContext } from "react";

const EditContext = createContext(null);

export const EditProvider = ({ value, children }) => {
  return <EditContext.Provider value={value}>{children}</EditContext.Provider>;
};

export const useEditData = () => useContext(EditContext);
